module.exports = __webpack_public_path__ + "img/back.9512018a.png";